import api from "../api";
import config from "../config";

export const usersService = {
  list: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/users/`);
    return res.data?.results ?? res.data ?? [];
  },

  remove: async (id) => {
    await api.delete(`${config.apiBaseUrl}/api/users/${id}/`);
  },

  update: async (id, payload) => {
    const res = await api.patch(`${config.apiBaseUrl}/api/users/${id}/`, payload);
    return res.data;
  },

  mailCorp: async () => {
    const res = await api.get(`${config.apiBaseUrl}/api/mail_corp/`);
    return res.data?.results ?? res.data ?? [];
  },

  createMailCorp: async (payload) => {
    const res = await api.post(`${config.apiBaseUrl}/api/mail_corp/`, payload);
    return res.data;
  },

  updateMailCorp: async (id, payload) => {
    const res = await api.patch(`${config.apiBaseUrl}/api/mail_corp/${id}/`, payload);
    return res.data;
  },

  getMailOAuthUrl: async ({ provider, account }) => {
    const tenantId =
      account.tenant_id ||
      String(account.account_id || account.account?.id || account.account || "LEGACY");

    const providerAppId =
      account.provider_app_id || account.provider_app?.id || account.provider_app;

    const params = new URLSearchParams();
    params.set("email", account.email || "");
    params.set("tenant_id", tenantId);
    params.set("post_message", "1");

    if (providerAppId) {
      params.set("provider_app_id", String(providerAppId));
    }

    const res = await api.get(
      `${config.apiBaseUrl}/api/mailoauth/connect-url/${provider}/?${params.toString()}`,
    );
    return res.data?.url;
  },

  unlinkMailOAuth: async (mailAccountId, provider) => {
    const res = await api.post(
      `${config.apiBaseUrl}/api/mailoauth/unlink/${provider}/`,
      {
        mail_account_id: mailAccountId,
      },
    );
    return res.data;
  },

  requestMicrosoftAdminConsent: async ({ mailAccountId, adminEmail }) => {
    const res = await api.post(
      `${config.apiBaseUrl}/api/mailoauth/microsoft/admin-consent/request/`,
      {
        mail_account_id: mailAccountId,
        admin_email: adminEmail,
      },
    );
    return res.data;
  },

  getMicrosoftAdminConsentStatus: async (mailAccountId) => {
    const res = await api.get(
      `${config.apiBaseUrl}/api/mailoauth/microsoft/admin-consent/status/`,
      {
        params: { mail_account_id: mailAccountId },
      },
    );
    return res.data;
  },

  listMailCorpUsers: async (mailCorpId) => {
    const res = await api.get(`${config.apiBaseUrl}/api/mail_corp/${mailCorpId}/users/`);
    return res.data?.results ?? res.data ?? [];
  },

  addMailCorpUser: async (mailCorpId, payload) => {
    const res = await api.post(`${config.apiBaseUrl}/api/mail_corp/${mailCorpId}/users/`, payload);
    return res.data;
  },

  updateMailCorpUserAssignment: async (mailCorpId, assignmentId, payload) => {
    const res = await api.patch(`${config.apiBaseUrl}/api/mail_corp/${mailCorpId}/users/${assignmentId}/`, payload);
    return res.data;
  },

  removeMailCorpUser: async (mailCorpId, assignmentId) => {
    await api.delete(`${config.apiBaseUrl}/api/mail_corp/${mailCorpId}/users/${assignmentId}/`);
  },


  changePassword: async ({ oldPassword, newPassword }) => {
    const res = await api.post(`/api/usuarios/me/password/`, {
      old_password: oldPassword,
      new_password: newPassword,
    });

    return res.data;
  },

  updateEmail: async ({ email }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      email,
    });

    return res.data;
  },

  updateName: async ({ firstName, lastName }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      first_name: firstName,
      last_name: lastName,
    });

    return res.data;
  },

  updatePhoto: async ({ photo }) => {
    const formData = new FormData();
    formData.append("photo", photo);

    const res = await api.put(`/api/usuarios/me/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  },

  updateTheme: async ({ theme }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      theme_preference: theme,
    });

    return res.data;
  },

  updateLanguage: async ({ language }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      language_preference: language,
    });

    return res.data;
  },

  updateTimezone: async ({ timezone }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      timezone,
    });

    return res.data;
  },

  updatePreferences: async ({ theme, language, timezone }) => {
    const res = await api.put(`/api/usuarios/me/`, {
      ...(theme && { theme_preference: theme }),
      ...(language && { language_preference: language }),
      ...(timezone && { timezone }),
    });

    return res.data;
  },
};
